import React from "react";
import PropTypes from "prop-types";
import { A, Btn, Link } from "./style";

const Button = ({
  display,
  role,
  tag,
  onClick,
  href,
  target,
  type,
  disabled,
  rel,
  children,
}) => {
  switch (tag) {
    default:
    case "button":
      return (
        <Btn
          display={display}
          role={role}
          onClick={onClick}
          disabled={disabled}
          type={type}
        >
          {children}
        </Btn>
      );
    case "link":
      return (
        <Link display={display} role={role} disabled={disabled} to={href}>
          {children}
        </Link>
      );
    case "a":
      return (
        <A
          display={display}
          role={role}
          disabled={disabled}
          href={href}
          target={target}
          rel={rel}
        >
          {children}
        </A>
      );
  }
};

Button.defaultProps = {
  display: "inline",
  role: "primary",
  type: 'button',
  tag: "button",
  disabled: false,
};

Button.propTypes = {
  display: PropTypes.oneOf(["block", "inline"]),
  type: PropTypes.string,
  role: PropTypes.oneOf(["primary", "secondary", "flat"]),
  tag: PropTypes.oneOf(["button", "link", "a"]),
  onClick: PropTypes.func,
  href: PropTypes.string,
  target: PropTypes.oneOf(["", "_blank"]),
  rel: PropTypes.string,
  disabled: PropTypes.bool,
};

export default Button;
